import { editCarSchema } from '../schema/editCarSchema'
import { getData } from '../assets/scripts/GeneralFunctions'
import { toast } from 'react-toastify'
import { errorList } from './stateList'

export const carEditSubmit = async (
  setIsSubmit,
  inputs,
  setShowModal,
  setCar,
  setError,
  car,
  error
) => {
  setIsSubmit(true)

  try {
    const validatedInputs = await editCarSchema.validate(inputs, { abortEarly: false })

    const queryParams = {
      car_model: validatedInputs.car_model,
      color: validatedInputs.color,
      monthly_ride: validatedInputs.monthly_ride,
      description: null,
      plate_number: {
        first: validatedInputs.first,
        letter: validatedInputs.letter,
        second: validatedInputs.second,
        state: validatedInputs.state,
      },
      aras_plate: validatedInputs.aras_plate,
    }

    const apiResult = await getData(`admin/cars/update/${car?.id}`, 'post', queryParams, true, true)
    if (apiResult?.status === 200) {
      setIsSubmit(false)
      setShowModal(false)
      setCar(apiResult?.data?.car)
      toast.success('موفقیت آمیز')
    } else {
      setError(apiResult?.error)
    }
  } catch (err) {
    setError({
      ...error,
      ...errorList(err),
    })
  } finally {
    setIsSubmit(false)
  }
}
